/*! hash:236adc3a1b5ab40120ca, chunkhash:2a66079ee7aa8be6cb10, name:index/index, filebase:index.2a66079ee.js, query:, file:assets/js/index/index.2a66079ee.js */
webpackJsonp([11],{

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
    location.replace("/m/index.html");
} else {
    location.replace("/pc/index.html");
}

/***/ })

},[7]);


// WEBPACK FOOTER //
// assets/js/index/index.2a66079ee.js